import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query ProductPage($id: ID!, $masterLimit: Int) {
      ProductPage: Product(id: $id) {
        ...productDetail
        ...productBigDetail
        ...productArtworks
        ...productFilms
        ...productCompanies
        ...productBrands
      }
    }
    ${fragments.productCompanies}
    ${fragments.productBrands}
    ${fragments.productFilms}
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.filmDetail}
    ${fragments.filmMasters}
    ${fragments.filmMasterDetail}
    ${fragments.stripDetail}
    ${fragments.filmHost}
    ${fragments.filmMasterPosterFrames}
    ${fragments.filmFiles}
    ${fragments.filmFileDetail}
    ${fragments.brandDetail}
    ${fragments.productBigDetail}
    ${fragments.brandArtworks}
    ${fragments.productDetail}
    ${fragments.productArtworks}
    ${fragments.productCategory}
    ${fragments.productCategoryTree}
    ${fragments.companyArtworks}
    ${fragments.companyNames}
    ${fragments.companyNameDetail}
    ${fragments.companyDetail}
    ${fragments.relationshipTypeDetail}
    ${fragments.filmBigAwards}
    ${fragments.awardPrizeArtworks}
    ${fragments.awardPrizeDetail}
    ${fragments.awardAncestor}
  `
